// lang/index.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementZhCNLocale from 'element-ui/lib/locale/lang/zh-CN' // 简体中文
import elementZhTWLocale from 'element-ui/lib/locale/lang/zh-TW' // 繁体中文
import cnLocale from './zh-CN'
import twLocale from './zh-TW'

Vue.use(VueI18n)

const messages = {
  'zh-CN': {
    ...cnLocale,
    ...elementZhCNLocale
  },
  'zh-TW': {
    ...twLocale,
    ...elementZhTWLocale
  }
}
export function getLanguage() {
  const chooseLanguage = localStorage.getItem("language");
  if (chooseLanguage) return chooseLanguage
  const language = 'zh-CN'
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return language
}

const i18n = new VueI18n({
  locale: getLanguage(),
  messages
})

export default i18n


// WEBPACK FOOTER //
// ./src/lang/index.js